(() => {
  const config = document.querySelector('[data-wishlist-config]');
  if (!config) return;

  const key = 'azha:wishlist:v1';
  const limit = Number(config.dataset.limit);
  const page = document.querySelector('[data-wishlist-page]');
  const list = page?.querySelector('[data-wishlist-list]');
  const empty = page?.querySelector('[data-wishlist-empty]');
  const status = document.querySelector('[data-wishlist-status]');
  const pageStatus = page?.querySelector('[data-wishlist-page-status]');
  let products = [];
  let renderVersion = 0;

  const valid = (product) => product && /^\d+$/.test(String(product.id)) && /^[a-z0-9][a-z0-9-]*$/.test(String(product.handle));
  const unique = (items) => {
    const seen = new Set();
    return items.filter((item) => {
      if (!valid(item) || seen.has(String(item.id))) return false;
      seen.add(String(item.id));
      return true;
    }).map(({ id, handle }) => ({ id: String(id), handle }));
  };
  const readStored = () => {
    try {
      return unique(JSON.parse(localStorage.getItem(key) || '[]'));
    } catch {
      return [];
    }
  };
  const message = (value) => {
    if (status) {
      status.textContent = value;
      status.dataset.empty = String(!value);
    }
    if (pageStatus) pageStatus.textContent = value;
  };
  const writeStored = (items) => {
    try {
      localStorage.setItem(key, JSON.stringify(items));
      return true;
    } catch {
      message(config.dataset.error);
      return false;
    }
  };
  const label = (button, saved) => {
    const template = saved ? config.dataset.removeLabel : config.dataset.addLabel;
    return template.replace('__TITLE__', button.dataset.productTitle || '');
  };
  const updateButtons = () => {
    const ids = new Set(products.map((product) => product.id));
    document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
      const saved = ids.has(button.dataset.productId);
      button.dataset.saved = String(saved);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', label(button, saved));
    });
  };
  const card = async (item) => {
    const article = document.createElement('article');
    article.className = 'overflow-hidden rounded-card border border-border bg-white';
    const info = document.createElement('div');
    info.className = 'flex flex-col gap-2 p-4';
    const title = document.createElement('a');
    title.className = 'font-heading text-lg text-primary hover:opacity-70';
    title.href = `${config.dataset.rootUrl}products/${encodeURIComponent(item.handle)}`;
    const detail = document.createElement('p');
    detail.className = 'text-sm text-muted';
    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'self-start text-sm font-medium text-primary underline underline-offset-4';
    remove.textContent = page.dataset.remove;
    remove.addEventListener('click', () => change('remove', item));

    try {
      const response = await fetch(`${config.dataset.rootUrl}products/${encodeURIComponent(item.handle)}.js`, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Product unavailable');
      const product = await response.json();
      if (String(product.id) !== item.id) throw new Error('Product changed');
      title.textContent = product.title;
      if (product.featured_image) {
        const imageLink = document.createElement('a');
        imageLink.href = title.href;
        const image = document.createElement('img');
        image.src = product.featured_image;
        image.alt = '';
        image.loading = 'lazy';
        image.className = 'aspect-square w-full object-cover bg-sand';
        imageLink.append(image);
        article.append(imageLink);
      }
      detail.textContent = product.available ? page.dataset.available : page.dataset.unavailable;
    } catch {
      title.textContent = page.dataset.removed;
      title.removeAttribute('href');
      detail.textContent = page.dataset.unavailable;
    }

    info.append(title, detail, remove);
    article.append(info);
    return article;
  };
  const render = async () => {
    updateButtons();
    if (!page || !list) return;
    const version = ++renderVersion;
    empty.hidden = products.length > 0;
    if (!products.length) {
      list.replaceChildren();
      return;
    }
    const cards = await Promise.all(products.map(card));
    if (version === renderVersion) list.replaceChildren(...cards);
  };
  const change = (action, item) => {
    const next = action === 'add' ? unique([...products, item]) : products.filter((product) => product.id !== item.id);
    if (next.length > limit) {
      message(config.dataset.limitError);
      return;
    }
    if (writeStored(next)) {
      products = next;
      message('');
    }
    render();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-button]');
    if (!button) return;
    const item = { id: button.dataset.productId, handle: button.dataset.productHandle };
    change(button.dataset.saved === 'true' ? 'remove' : 'add', item);
  });
  window.addEventListener('storage', (event) => {
    if (event.key === key) {
      products = readStored();
      render();
    }
  });

  products = readStored();
  render();
})();
